// ===== WhatsApp Lead Capture Script (FINAL VERSION) =====

console.log("✅ WhatsApp Lead Capture Script Loaded");

const API_BASE = "https://backend-service-xady.onrender.com";

document.addEventListener("mousedown", async function (e) {
  const btn = e.target.closest("[data-whatsapp-lead]");
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  console.log("👉 WhatsApp button clicked");

  const phoneNumber = btn.dataset.waNumber;
  const message = btn.dataset.waMessage || "";
  const product = btn.dataset.product || "";
  const pageUrl = window.location.href;

  // 🔥 STEP 1 — ASK PHONE (POPUP)
  let userPhone = prompt("Enter your WhatsApp number:");

  if (!userPhone) {
    alert("Phone number is required");
    return;
  }

  userPhone = userPhone.replace(/\D/g, "");

  if (!/^[6-9]\d{9}$/.test(userPhone)) {
    alert("Enter valid 10 digit number");
    return;
  }

  console.log("📞 Captured phone:", userPhone);

  // 🔥 STEP 2 — OPEN WHATSAPP INSTANTLY
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, "_blank");

  // 🔥 STEP 3 — SEND TO BACKEND
  console.log("🔥 FINAL PHONE SENT:", userPhone);
  
  const payload = {
    phone: userPhone,
    product,
    message,
    action: "whatsapp_click",
    page_url: pageUrl,
  };

  console.log("🔥 FINAL PAYLOAD:", payload);

  try {
    console.log("🚀 Sending lead to:", `${API_BASE}/api/leads/shopify`);

    const res = await fetch(`${API_BASE}/api/leads/shopify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    console.log("✅ [WA Lead] API success:", data);
  } catch (err) {
    console.error("❌ [WA Lead] API failed:", err);
  }
});